.root {
  padding: 16px;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  margin-top: 80px;

  h1 {
    text-align: center;
    margin-bottom: 40px;

    a {
      text-decoration: none;
      color: #1f5be4;

      &:hover {
        color: #3597fc;
      }
    }
  }
}
